import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { AlertifyService } from 'src/app/services/alertify.service';
import { EmpresaService } from 'src/app/services/empresa.service';

@Component({
  selector: 'app-edit-fecha-fin-servicio-empresa',
  templateUrl: './edit-fecha-fin-servicio-empresa.component.html',
  styleUrls: ['./edit-fecha-fin-servicio-empresa.component.scss']
})
export class EditFechaFinServicioEmpresaComponent implements OnInit {
  public documentos: any;
  registerForm: UntypedFormGroup;
  public isForEdit = false;
  public dataInput: any;
  public minDate:any;
  public maxDate:any;
  constructor(
    public empresaSvc: EmpresaService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditFechaFinServicioEmpresaComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);
  }

  ngOnInit(): void {

    const currentYear = moment().year();
    this.minDate = moment();
    this.maxDate = moment([currentYear + 1, 11, 31])

    this.registerForm = new UntypedFormGroup({
      empresaId: new UntypedFormControl('', Validators.required),
      fecha: new UntypedFormControl('', Validators.required),

    });
    this.registerForm.get('empresaId')?.setValue(this.dataInput);

  }

  guardar() {
    console.log('guardar fecha fin serv');
    console.log(this.registerForm.value);
      //aqui mando a editar
      this.empresaSvc.editFechaServicioEmpresa(this.registerForm.value).subscribe((res) => {
        console.log('resultado Editar: ', res);
        if (res) {
          this.alertify.success('Fecha actualizada');
          this.dialogRef.close();
        } else {
          this.alertify.error('La fecha no se ha podido actualizar');
        }
      });
  }
}
